import { render, staticRenderFns } from "./health-record-detail.vue?vue&type=template&id=6b8c4dc8&"
import script from "./health-record-detail.vue?vue&type=script&lang=js&"
export * from "./health-record-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports